import { render, staticRenderFns } from "./CriterionType.vue?vue&type=template&id=6c35e674"
import script from "./CriterionType.vue?vue&type=script&lang=js"
export * from "./CriterionType.vue?vue&type=script&lang=js"
import style0 from "./CriterionType.vue?vue&type=style&index=0&id=6c35e674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports